import PageShell from "./PageShell";

const POSTS = [
  { title: "Understanding 999.9 purity standards", date: "Coming soon", desc: "A primer on how purity is measured, certified and verified across global refineries." },
  { title: "Inside an XRF assay laboratory", date: "Coming soon", desc: "A look at the instruments and protocols that underpin assay certification." },
  { title: "The economics of precious-metal recovery", date: "Coming soon", desc: "How recovery yields impact margins for jewellers and bullion dealers." },
];

export default function Blog() {
  return (
    <PageShell
      testId="blog-page"
      eyebrow="Insights"
      title="Notes from the refinery."
      intro="Articles, explainers and field notes from Agroya's engineers and analysts. New essays publishing soon."
      seo={{
        title: "Blog · Agroya Refinery LLP",
        description: "Articles, explainers and field notes from Agroya Refinery — precious metals, purity, assaying and industry insight.",
        canonical: "https://agroya1935.com/blog",
      }}
    >
      <div className="grid gap-4 not-prose">
        {POSTS.map((p, i) => (
          <div key={i} data-testid={`post-${i}`} className="p-6 border border-[#E5E5E5] rounded-lg bg-white lift-card">
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] font-semibold">{p.date}</div>
            <div className="font-heading text-xl font-medium text-[#0A0A0A] mt-2">{p.title}</div>
            <p className="mt-2 text-sm text-[#4B5563] leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
